import { type TagParser } from './tagParser';
import { ParserRegistry } from './parserRegistry';

class LetOpTagParser implements TagParser {
  tag = 'letop';

  parse() {
    return {
      html: '<i class="fa fa-exclamation-triangle text-red-400 mr-2"></i>',
      consumedLength: 0,
    };
  }
}

ParserRegistry.register(new LetOpTagParser());
